import {
  CancelGuide,
  FinanceAccount,
  SpendingCategory,
  Subscription,
} from "@/types/subscription";
import axios from "axios";
import { POST } from "./index";
import { Platform } from "react-native";
import { Transaction } from "@/types/transactions";

// Sign in response interface (adjust based on your API response structure)

type FinanceAccountListResponse = {
  data: FinanceAccount[];
};

export interface TransactionPeriod {
  transactions: any[];
  total: number; // in cents
}

export interface TransactionAnalysis {
  month: TransactionPeriod;
  year: TransactionPeriod;
}

// Authentication service functions
const SubscriptionServices = {
  /**
   * Get list of feed items
   * @returns Promise<ApiResponse<FeedItemListResponse>>
   */
  getPlaidLinkToken: async (userId?: string) => {
    return await POST<{ linkToken: string }>(
      "/finance-account/create-plaid-link-token",
      {
        userId,
        isAndroid: Platform.OS === "android",
      }
    );
  },
  createAccount: async ({
    publicToken,
    metadata,
    userId,
  }: {
    publicToken: string;
    metadata: any;
    userId?: string;
  }) => {
    return await POST<{
      id: string;
      name: string;
      accountCount: number;
      accounts: {
        name: string;
        mask: string;
        type: string;
        subtype: string;
      }[];
    }>("/finance-account/create", {
      publicToken,
      metadata,
      userId,
    });
  },
  getListAccounts: async () => {
    return await POST<FinanceAccountListResponse>("/finance-account/list");
  },
  createSubscription: async (userId?: string) => {
    return await POST<any>("/subscription-search/create", {
      userId,
    });
  },
  getSubscriptions: async () => {
    return await POST<{ subscriptions: Subscription[] }>(
      "/subscription-search/get"
    );
  },
  fetchBrandIcon: async (brandName: string) => {
    return axios.get<
      {
        brandId: string;
        claimed: boolean;
        domain: string;
        name: string;
        icon: string;
        _score: number;
        qualityScore: number;
        verified: boolean;
      }[]
    >(`https://api.brandfetch.io/v2/search/${brandName}?c=1idou6xlNMQkRxH0bfG`);
  },
  getCancelGuide: async (merchantId: string) => {
    return await POST<CancelGuide>("/cancel-guide/get", {
      merchantId,
    });
  },
  analyzePending: async () => {
    return await POST<{
      month: {
        transactions: Transaction[];
        total: number;
      };
      year: {
        transactions: Transaction[];
        total: number;
      };
    }>("/spending/transactions", {});
  },
  unlinkAccount: async (id: string) => {
    return await POST<{ success: boolean }>("/finance-account/unlink", { id });
  },
};

export default SubscriptionServices;
